<template>
  <div style="display: inline;height: 100%;display: flex;flex-direction: column;">
    <el-form size="mini" :inline="true" :model="formData" class="demo-form-inline" style="margin: 0 25px;">
      <el-form-item :label="$t('chuangjianshijian')">
        <yi_time_input type="datetimerange" :start.sync="formData.createTimeStart" :end.sync="formData.createTimeEnd"></yi_time_input>
      </el-form-item>
      <el-form-item :label="$t('jihuawanchengshijian')">
        <yi_time_input type="datetimerange" :start.sync="formData.planTimeStart" :end.sync="formData.planTimeEnd"></yi_time_input>
      </el-form-item>
      <el-form-item :label="$t('shijiwanchengshijian')">
        <yi_time_input type="datetimerange" :start.sync="formData.actualTimeStart" :end.sync="formData.actualTimeEnd"></yi_time_input>
      </el-form-item>
      <el-form-item>
        <el-button @click="calculateNum()" type="primary" plain="plain">
          {{ $t('sousuo') }}
        </el-button>
      </el-form-item>
    </el-form>
    <el-card style="margin: 20px;overflow: auto;">
      <div class="card-grid-container">
        <div class="card-grid-item gridStyle" @click="changeTabTo(1)">
          <div>{{$t('jianyangongdanzongshu')}}</div><div style="text-align: center;">{{workCount}}</div>
        </div>
        <div class="card-grid-item gridStyle" @click="changeTabTo(2)">
          <div>{{$t('jianyantongguo')}}</div><div>{{workPass}}</div>
        </div>
        <div class="card-grid-item gridStyle" @click="changeTabTo(3)">
          <div>{{$t('jianyanbuhege')}}</div><div>{{workNotPass}}</div>
        </div>
        <div class="card-grid-item gridStyle" @click="changeTabTo(4)">
          <div>{{$t('weijianyan')+'/'+$t('zuofei')}}</div><div>{{workTodo+'/'+workCancel}}</div>
        </div>
        <div class="card-grid-item gridStyle" @click="changeTabTo(5)">
          <div>{{$t('shoujian')}}</div><div>{{workFirst}}</div>
        </div>
        <div class="card-grid-item gridStyle" @click="changeTabTo(6)">
          <div>{{$t('mojian')}}</div><div>{{workLast}}</div>
        </div>
        <div class="card-grid-item gridStyle" @click="changeTabTo(7)">
          <div>{{$t('chouyangjianyan')}}</div><div>{{workSpotCheck}}</div>
        </div>
        <div class="card-grid-item gridStyle" @click="changeTabTo(8)">
          <div>{{$t('chengpinjianyan')}}</div><div>{{workFinishedProduct}}</div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script type="text/javascript">
export default {
  data() {
    return {
      formData:{},
      workCount: 0,
      workPass: 0,
      workNotPass: 0,
      workTodo: 0,
      workCancel: 0,
      workFirst: 0,
      workLast: 0,
      workSpotCheck: 0,
      workFinishedProduct: 0,
    }
  },
  mounted() {

  },
  created() {
    setTimeout(() => {
      //创建时间默认为当月1号00:00:00至当月最后1天23:59:59
      this.$set(this.formData, 'createTimeStart', this.begin());
      this.$set(this.formData, 'createTimeEnd', this.end());
      this.calculateNum();
    }, 300);
  },
  methods: {
    changeTabTo(itemIndex){
      if (itemIndex === 1) {
        this.formData.statusList = null;
        this.formData.inspectionType = null;
        // 总数，不做处理
      } else {
        // 根据不同类型设置筛选条件
        switch (itemIndex) {
          case 2: // 检验通过
            this.formData.statusList = ["2"];
            this.formData.inspectionType = null;
            break;
          case 3: // 检验不通过
            this.formData.statusList = ["3"];
            this.formData.inspectionType = null;
            break;
          case 4: // 未检验/作废
            this.formData.statusList = ["1", "4"];
            this.formData.inspectionType = null;
            break;
          case 5: // 首检
            this.formData.inspectionType = "1";
            this.formData.statusList = null;
            break;
          case 6: // 末检
            this.formData.inspectionType = "3";
            this.formData.statusList = null;
            break;
          case 7: // 抽检
            this.formData.inspectionType = "2";
            this.formData.statusList = null;
            break;
          case 8: // 成品检验
            this.formData.inspectionType = "4";
            this.formData.statusList = null;
            break;
        }
      }
      this.changeToDetail();
    },
    changeToDetail(){
      this.$emit('setParam', {
          ...this.formData,
      })
      this.$parent.tabClick({name: "mingxi"});
    },
    calculateNum() {
      this.loading = true;
      // 获取统计数据
      this.http.post('/web/quality/inspection/record/getReportStatistic', this.formData).then(response => {
        let res = response.data;
        // 更新统计项显示值
        this.workCount = Number(res.workCount || 0);
        this.workPass = Number(res.workPass || 0);
        this.workNotPass = Number(res.workNotPass || 0);
        this.workTodo = Number(res.workTodo || 0);
        this.workCancel = Number(res.workCancel || 0);
        this.workFirst = Number(res.workFirst || 0);
        this.workLast = Number(res.workLast || 0);
        this.workSpotCheck = Number(res.workSpotCheck || 0);
        this.workFinishedProduct = Number(res.workFinishedProduct || 0);
      }).catch(error => {
        this.$message.error(this.$t(error))
      }).finally(() => {
        this.loading = false
      })
    },
    begin() {
      const date = new Date();
      const begin = (new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0)).getTime();
      return begin;
    },
    end() {
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const lastDay = new Date(year, month, 0).getDate();
      const end = (new Date(year, month - 1, lastDay, 23, 59, 59)).getTime();
      return end;
    },
  }
}
</script>

<style scoped lang="scss">
.report-summary {
  padding: 20px;
}

.detail {
  margin-top: 20px;
}

.middle {
  min-height: 400px;
}

.card-grid-container {
  display: flex;
  flex-wrap: wrap;
  border-top: 1px solid #f0f0f0;
  border-left: 1px solid #f0f0f0;

}

.card-grid-item {
  border-right: 1px solid #f0f0f0;
  border-bottom: 1px solid #f0f0f0;
}

.card-grid-item:hover {
  background-color: #f5f7fa;
  cursor: pointer;
}

.gridStyle {
  width: 25%;
  textAlign: center;
  cursor: pointer;
  padding: 30px 20px;
  font-size: 22px;
  text-align: center;
}
</style>